import React from "react";
import { connect } from "react-redux";
import DossierActions from "../redux/DossierRedux";
import { Link, Redirect } from "react-router-dom";

import Layout from "../components/Layout";
import Button from "../components/UI/Button/Button";
import HeaderForm from "../components/HeaderForm/HeaderForm";
import { getFrontDate, isFormReadOnly } from "../shared/utility";
import { votreBien } from "../shared/staticTexts";

import "./DossierVotreBien.scss";

class DossierVotreBien extends React.Component {
  constructor(props) {
    super(props);
    if (props.dossier === null) {
      props.history.push("/dossier");
    }

    const dossier = props.dossier;

    this.state = {
      isReadOnlyForm: isFormReadOnly(dossier),
    };
  }

  handleModifyButton = (bienId) => {
    this.props.history.push({
      pathname: "/dossier/votre-bien-form",
      state: { currentBienId: bienId },
    });
  };

  handleDeleteButton = (bienId) => {
    var result = window.confirm(
      "Voulez-vous supprimer Bien n°" + bienId + " ?"
    );
    if (result) {
      const updatedDossier = this.props.dossier.merge({
        biens: this.props.dossier.biens.filter((bien) => bien.id !== bienId),
      });
      this.props.saveDossier(updatedDossier);
    }
  };

  render() {
    let errorsMessages = "";
    if (this.props.error && this.props.errorMessage !== null) {
      errorsMessages = (
        <div className="alert alert-danger" role="alert">
          {this.props.errorMessage}
        </div>
      );
    }

    let annee = "";
    if (this.props.dossier !== null) {
      annee = this.props.dossier.annee;
    }

    return (
      <Layout>
        {errorsMessages}
        <HeaderForm
          step="2"
          annee={annee}
          isReadOnlyForm={this.state.isReadOnlyForm}
        />
        <h1 className="text-center">
          {this.props.dossier &&
          this.props.dossier.biens &&
          this.props.dossier.biens.length > 1
            ? votreBien.title2
            : votreBien.title1}
        </h1>
        {this.props.dossier &&
        this.props.dossier.biens &&
        this.props.dossier.biens.length > 0 ? (
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <table className="table vertical-center my-5">
                  <tbody>
                    {this.props.dossier.biens.map((bien) => {
                      return (
                        <tr key={bien.id}>
                          <td className="align-middle">
                            Bien n° {bien.id} | {bien.adresse} -{" "}
                            {bien.codePostal} {bien.ville} |{" "}
                            {getFrontDate(bien.dateAcquisition)}
                          </td>
                          <td className="text-right col-action">
                            <Button
                              classes="btn btn-primary"
                              btnType="button"
                              clicked={(bienId) =>
                                this.handleModifyButton(bien.id)
                              }
                            >
                              {!this.state.isReadOnlyForm ? "Modifier" : "Voir"}
                            </Button>

                            {!this.state.isReadOnlyForm ? (
                              <Button
                                classes="btn btn-danger ml-3"
                                btnType="button"
                                clicked={(bienId) =>
                                  this.handleDeleteButton(bien.id)
                                }
                              >
                                Supprimer
                              </Button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {!this.state.isReadOnlyForm ? (
                <div className="col-lg-8 text-right mb-5">
                  <Link
                    to="/dossier/votre-bien-form"
                    className="btn btn-default"
                  >
                    {votreBien.linkAddNew}
                  </Link>
                </div>
              ) : (
                ""
              )}

              <div className="col-lg-8 my-5">
                <Link
                  to="/dossier/adresse"
                  className="btn btn-default float-left"
                >
                  {votreBien.buttonReturn}
                </Link>
                <Link
                  to="/dossier/votre-activite"
                  className="btn btn-success float-right"
                >
                  {votreBien.buttonSubmit}
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <Redirect to="/dossier/votre-bien-form" />
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDossier: (id) => dispatch(DossierActions.getDossier(id)),
    saveDossier: (dossier) => dispatch(DossierActions.saveDossier(dossier)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DossierVotreBien);
